export default {
	common: {
		guid: 7219,
		share: 4105,
		noActiveJobBoards: 7243,
		postingNotPossible: 7244,
		jobShareDescription: 9022,
		validationSummaryFormat: 9052,
		validationShowMore: 9056,
		jobShareSuccessTip: 7227,
		selectedJobBoards: 7229,
		province: 15139,
	},
	jobPost: {
		repost: 7189,
		delete: 7191,
		postings: 7196,
		multiActionWizardDescription: 7201,
		multiRejectWizardRejectReason: 7206,
		postingFrom: 7209,
		postingPeriod: 7255,
		jobPostPostingDetails: 7260,
		lastProcessedDate: 7281,
		reject: 9031,
		rejectPosting: 9033,
		rejectPostingQuestion: 9034,
		jobPostsToDelete: 9088,
		jobPostsToCancel: 9089,
		jobPostsToReject: 9090,
	},
	jobBoard: {
		singular: 7150,
		targetArea: 7179,
		jobCategories: 7182,
		industries: 7183,
		jobTypes: 7184,
		educationLevels: 7185,
		type: 7186,
		searchPlaceholder: 7192,
		postings: 7196,
		note: 7200,
		cost: 7218,
		fieldsValidation: 7223,
		maxLength: 7225,
		minLength: 7226,
		addToMyJobBoards: 7237,
		addJobBoard: 7238,
		experienceLevels: 7239,
		employmentTypes: 7240,
		matching: 7245,
		posting: 7257,
		guid: 7282,
		key: 7284,
		connectionType: 7286,
		bodyTemplate: 7294,
		contentType: 7295,
		jobPostIdTest: 7296,
		jobPostUrlPath: 7297,
		jobPostUrlTemplate: 7298,
		statusPath: 7299,
		successValue: 7300,
		label: 9007,
		errorMessagePath: 9008,
		httpMethod: 9009,
		headers: 9010,
		urlTemplate: 9012,
		myJobBoard: 9013,
		successRegularExpression: 9014,
		response: 9015,
		request: 9016,
		allJobBoards: 9019,
		addJobBoardConfirmation: 9021,
		configuration: 9037,
		myJobBoardSettings: 9059,
		delete: 9084,
		authentication: 9092,
		changeOrganization: 9095,
		changeOrganizationModalWarning: 9096,
		blockOldOrganization: 9097,
		perMyJobBoard: 9098,
		postingTypes: 9105,
		jobPostTypeUnderMaintenance: 9107,
		helloFlexId: 9108,
		jobPostType: 9110,
		additionalInformation: 9115,
		deleteConfirmation: 14329,
	},
	jobBoardInstance: {
		facebookLoginButtonText: 1856,
		jobType: 3479,
		industry: 3614,
		educationLevel: 3615,
		category: 5516,
		approveRequired: 7166,
		targetArea: 7179,
		rating: 7208,
		saveAndSignIn: 7261,
		myJobBoards: 9018,
		jobBoardStatus: 9025,
		myJobBoardStatus: 9026,
		personalJobPostApiUrl: 9099,
		personalJobPostApiUrlDescription: 9100,
		noAvailableJobPostTypes: 9109,
		postingTypes: 9105,
	},
	logs: {
		plural: 9005,
		jobPostGuid: 7219,
		requestDetails: 7220,
		responseDetails: 7221,
		jobPostGuidPlaceholder: 7283,
		date: 14367,
	},
};
